<template>
  <!-- 国内退票详情 -->
  <div>
    <div class="Details_data">
      <h4>退票单详情</h4>
      <div class="Details_text">
        <span>退票单号：{{detailData.refundOderNo||defaultText}}</span>
        <span
          @click="$router.push({name:'air-ticket-admin-airDetails',query:{ordersNo:detailData.orderNo}})"
        >
          订单号：
          <span style="color:#237dc8;cursor:pointer;">{{detailData.orderNo||defaultText}}</span>
        </span>
        <span>退票状态：{{detailData.refundStatusText||defaultText}}</span>
        <span>申请时间：{{detailData.appTime||defaultText}}</span>
        <span>航程类型：{{detailData.flightTypeText}}</span>
        <span>订单总金额：￥{{detailData.amount||defaultText}}</span>
        <span>退票金额：￥{{detailData.refundPayAmount||defaultText}}</span>
        <span>退票时间：{{detailData.refundTime||defaultText}}</span>
        <span v-if="detailData.fullReductionAmount">实际支付金额：￥{{detailData.payAmount||defaultText}}</span>
        <span class="price" v-if="detailData.fullReductionAmount">
          优惠金额：￥{{detailData.fullReductionAmount||defaultText}}
          <el-popover placement="bottom" width="500" trigger="hover">
            <div
              class="activity_text"
              v-for="(item,index) in detailData.fullReductionSnapshot"
              :key="index"
            >
              <p>
                <b>{{index}}</b>
                {{item}}
              </p>
            </div>
            <b slot="reference">优惠说明</b>
          </el-popover>
        </span>
      </div>
    </div>
    <div class="content-list">
      <h2>退票信息</h2>
      <div
        class="content_table"
        v-for="(psgInfo,index) in detailData.psgAndSegmentResList"
        :key="index"
      >
        <div class="passenger-list fs13">
          <span>乘客姓名：{{psgInfo.psgName}}</span>
          <span>乘客类型：{{psgInfo.psgTypeText}}</span>
          <span>证件类型：{{psgInfo.cardTypeText}}</span>
          <span>证件号码：{{psgInfo.cardNo}}</span>
        </div>
        <table width="95%" v-for="(fligth,index) in psgInfo.segmentInfoList" :key="index">
          <tr>
            <th>航程</th>
            <th>航空公司</th>
            <th>航班号</th>
            <th>舱位</th>
            <th>起抵地</th>
            <th>起飞时间</th>
            <th>到达时间</th>
            <th>票号</th>
            <th v-if="$route.query.psgType == 2">成人票号</th>
          </tr>
          <tr>
            <td>{{fligth.segmentTypeText}}</td>
            <td>{{fligth.airlineName}}</td>
            <td>{{fligth.flightNo}}</td>
            <td>{{fligth.cabinCode}}</td>
            <td>
              {{fligth.sCityName + fligth.sAirportCode}}-
              {{fligth.eCityName + fligth.eAirportCode}}
            </td>
            <td>{{fligth.beginDate}} {{fligth.beginTime}}</td>
            <td>{{fligth.arriveDate}} {{fligth.arriveTime}}</td>
            <td>{{fligth.ticketNumber}}</td>
            <td v-if="$route.query.psgType == 2">
              <span
                style="color:#237dc8;cursor:pointer"
                @click="goPage(fligth.adultOrderNo)"
              >{{fligth.adultTicketNumber|| '----'}}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="content-list">
      <h2>申请内容</h2>
      <div class="fs13" style="padding:15px 30px">
        <p>
          退票类型：
          <span>{{detailData.refundTypeText}}</span>
        </p>
        <p>
          座位情况：
          <span>{{detailData.seatStatusText}}</span>
        </p>
        <p class="img-box">延误/病退证明：
          <el-image
            style="width: 100px; height: 100px"
            :src="detailData.img"
            :preview-src-list="detailData.imgList"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </p>
        <p>
          备注：
          <span>{{detailData.remark}}</span>
        </p>
      </div>
    </div>
    <div class="content-list">
      <h2>退票说明</h2>
      <div style="padding:15px 30px" class="fs13">
        <p>1、平台退改工作时间：8:30 ~ 22:00 (周一至周日)，请您提交退票时尽量在工作时段内提交，避免产生损失；</p>
        <p>2、退票成功，退款会于5个工作日内退还，详情可咨询客服。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InlandOrderInfo",
  data() {
    return {
      defaultText: "-----"
    };
  },
  props: ["detailData"],
  methods: {
    goPage(val) {
      if (!val) return;
      this.$router.push({
        name: "air-ticket-admin-international-list-detail",
        query: { ordersNo: val }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";
.content-list {
  @contentBox();
  .img-box {
    display: flex;
    align-items: stretch;
  }
}
.content_table {
  @contentTable();
}
.content_table-color {
  @contentTableColor();
}
.luggage-info {
  padding: 10px 25px;
  p {
    padding: 5px 0;
  }
}
.fs13 {
  p {
    padding: 10px 0;
  }
}
.Details_data {
  background: #fffcfa;
  border: solid 1px #ffb27f;
  h4 {
    padding-left: 30px;
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    padding: 8px 30px;
    background: #fff5ef;
  }
  .Details_text {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 20px 30px;
    span {
      display: inline-block;
      width: 33%;
      font-size: 13px;
      color: #666;
      line-height: 25px;
      height: 25px;
    }
    .price {
      b {
        cursor: pointer;
        color: #237dd2;
      }
    }
  }
}

.passenger-list {
  padding: 10px 25px;
  background: #ecf6ff6e;
  border-bottom: 1px dashed #dfdfdf;
  span {
    padding-right: 40px;
  }
}
.activity_text {
  font-size: 13px;
  color: #666;
  text-align: justify;
  p {
    line-height: 25px;
  }
}
</style>
